<script setup lang="ts">
  import { computed } from 'vue';
  import { useRouter } from 'vue-router';
  import { Checkbox } from '@/shared/ui';
  import RecordActionsCell from './RecordActionsCell.vue';
  import type { RecordAction, RejectedItem } from '../model/models.types';

  const props = withDefaults(
    defineProps<{
      rejected: RejectedItem;
      isSelected: boolean;
      canDelete?: boolean;
    }>(),
    { canDelete: false }
  );

  const emit = defineEmits<{
    'toggle-selection': [id: number];
    delete: [rejected: RejectedItem];
  }>();

  const router = useRouter();

  const hiddenActions = computed<RecordAction[]>(() => (props.canDelete ? [] : ['delete']));

  function handleAction(action: RecordAction): void {
    if (action === 'delete') {
      emit('delete', props.rejected);
      return;
    }
    if (action === 'view') {
      router.push({
        name: 'GestaoRegistrosReprovadoVisualizar',
        params: { id: props.rejected.id },
      });
      return;
    }
    if (action === 'edit') {
      router.push({
        name: 'EditarFormulario',
        params: { id: String(props.rejected.id) },
        query: { origem: 'reprovados' },
      });
    }
  }
</script>

<template>
  <tr class="table-row-hover border-t border-gray-02 transition-colors duration-300 ease-out">
    <td class="pl-4 pr-2 py-4.5 align-middle leading-[0]">
      <Checkbox
        :id="rejected.id"
        :checked="isSelected"
        @toggle="emit('toggle-selection', rejected.id)"
      />
    </td>
    <!-- Registro -->
    <td class="py-4.5 text-sm text-gray-07 text-left align-middle whitespace-nowrap">
      {{ rejected.registry }}
    </td>
    <!-- Título -->
    <td class="pl-6 py-4.5 text-sm text-gray-07 text-left align-middle min-w-80">
      {{ rejected.title }}
    </td>
    <!-- Rev. -->
    <td class="pl-6 py-4.5 text-sm text-gray-07 text-left align-middle whitespace-nowrap">
      {{ rejected.revision }}
    </td>
    <!-- Data da reprovação -->
    <td class="pl-6 py-4.5 text-sm text-gray-07 text-left align-middle w-full whitespace-nowrap">
      {{ rejected.rejectionDate }}
    </td>
    <!-- Ações -->
    <RecordActionsCell
      :hidden-actions="hiddenActions"
      @action="handleAction"
    />
  </tr>
</template>
